<template>
  <span>
    <template v-for="(child, idx) in displayChildren" :key="child.id">
      <router-link :to="'/node/' + child.id" class="text-white font-weight-bold" @click="onNavigate">{{ child.name }}</router-link>
      <span v-if="idx < displayChildren.length - 1">
        <span v-if="idx === displayChildren.length - 2 && othersCount === 0">&nbsp;{{ $t('common.and') }}&nbsp;</span>
        <span v-else>, </span>
      </span>
    </template>
    <span v-if="othersCount > 0">&nbsp;{{ $t('common.and') }} {{ $t('common.others', othersCount, { count: othersCount }) }}</span>
  </span>
</template>

<script>
/**
 * Renders a formatted list of children that exceed the depth limit.
 * Formatting rules:
 *   1 child:  a
 *   2 children: a and b
 *   3 children: a, b and c
 *   4+ children: a, b, c and N others
 *
 * Each child name is rendered as a router-link.
 */
export default {
  name: 'DepthExceededChildren',
  props: {
    children: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onNavigate(event) {
      if (event.ctrlKey || event.metaKey) return;
      this.$emit('navigate');
    },
  },
  computed: {
    displayChildren() {
      if (this.children.length <= 3) return this.children;
      return this.children.slice(0, 3);
    },
    othersCount() {
      return Math.max(0, this.children.length - 3);
    },
  },
};
</script>

<style lang="scss" scoped>
@at-root {
  @layer app {
    a:not(.v-btn):not(.v-list-item--link) {
      color: rgb(var(--v-theme-on-error));
    }
  }
}
</style>
